<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare content='1、拼团订单：您使用了拼团购功能，用户参与产生的拼团订单。
      2、拼团成功的订单才可以操作发货，拼团失败的订单，您需要在1-3个工作日内确认并退款给买家。
      3、如果用户参与的是多级拼团且已达到更高的拼团级别，您需要及时进行退还差价处理，退还差额不计为退款订单。' :padding='false'></SmallSquare>
      <a-tabs >
        <a-tab-pane key="1" tab="总部"></a-tab-pane>
        <a-tab-pane key="2" tab="门店"></a-tab-pane>
      </a-tabs>
      <div class="s_flex_ali m-t-10 m-b-25">
        <div class="fz-16 s_font_b width20 s_c333">下单人数：<span class="s_cd41">520</span></div>
        <div class="fz-16 s_font_b width20 s_c333">下单笔数：<span class="s_cd41">520</span></div>
        <div class="fz-16 s_font_b width20 s_c333">参团单数：<span class="s_cd41">520</span></div>
        <div class="fz-16 s_font_b width20 s_c333">成团单数：<span class="s_cd41">520</span></div>
        <div class="fz-16 s_font_b width20 s_c333">成团金额：<span class="s_cd41">520</span></div>
      </div>
      <a-radio-group class="m-b-25" v-model:value="search.value1" button-style="solid">
        <a-radio-button :value="7">近7天</a-radio-button>
        <a-radio-button :value="30">近30天</a-radio-button>
      </a-radio-group>
      <div class="m-b-25">
        <a-radio-group v-model:value="search.value1" button-style="solid">
          <a-radio-button :value="7">全部订单</a-radio-button>
          <a-radio-button :value="30">待付款（0）</a-radio-button>
          <a-radio-button :value="30">待发货（0）</a-radio-button>
          <a-radio-button :value="30">待收获（0）</a-radio-button>
          <a-radio-button :value="30">退款订单</a-radio-button>
        </a-radio-group>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item class='mb15' label="" name='keywords'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.select" style="width: 30%" @change="inputSelect">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="Option1">订单号</a-select-option>
              <a-select-option value="Option2">买家ID</a-select-option>
              <a-select-option value="Option2">联系手机</a-select-option>
              <a-select-option value="Option2">收货人</a-select-option>
              <a-select-option value="Option2">运单号</a-select-option>
              <a-select-option value="Option2">微信昵称</a-select-option>
              <a-select-option value="Option2">交易单号</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keywords"  placeholder="请输入关键词进行搜索"/>
          </a-input-group>
        </a-form-item>
        <a-form-item label="收获区域" name='level_id' v-if='open'>
          <a-select class='m-r-10' v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">Zone one</a-select-option>
            <a-select-option value="beijing">Zone two</a-select-option>
          </a-select>
          <a-select v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">Zone one</a-select-option>
            <a-select-option value="beijing">Zone two</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="订单类型" name='level_id' v-if='open'>
          <a-select class='m-r-10' v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">Zone one</a-select-option>
            <a-select-option value="beijing">Zone two</a-select-option>
          </a-select>
          <a-select v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部" >
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">Zone one</a-select-option>
            <a-select-option value="beijing">Zone two</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="优惠折扣" name='level_id' v-if='open'>
          <a-select v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">优惠券折扣</a-select-option>
            <a-select-option value="beijing">满额包邮</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="创建日期" name='time' v-if='open'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
        <!-- <a-form-item>
          <a-button type="primary" ghost>批量发货</a-button>
        </a-form-item> -->
        <a-form-item>
          <a href="javascript:;" @click='open = !open'>{{open ? '收起':'展开'}}</a>
          <UpOutlined v-if='open'/>
          <DownOutlined  v-else/>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns='columns' :data-source='data'>
        <template #expandedRowRender="{ record }">
          <p style="margin: 0">
            {{ record.userInfo }}
          </p>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <router-link :to="'/agent/agent_level/detail?type=look&id='+record.id">
                    <a href="javascript:;">详情</a>
                  </router-link>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:agentDel="()=>agentDel(record)" href="javascript:;">售后处理</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="showAddress = true" href="javascript:;">修改收货地址</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:agentDisable="()=>agentDisable(record)" href="javascript:;">标记发货</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:agentDel="()=>agentDel(record)" href="javascript:;">缺货退款</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数:${total} `" />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false"
    title="修改收货地址"
    :width='600'
    centered
    :footer="null"
    v-model:visible="showAddress"
    destroyOnClose
  >
    <addressChange :addressData='addressData' v-on:submitaddress='submitAddress'></addressChange>
  </a-modal>
  <a-modal  :keyboard="false"
    title="退货退款"
    :width='600'
    centered
    :footer="null"
    v-model:visible="showRefunds"
    destroyOnClose
  >
    <refundsForem :refundsData='addressData' v-on:submitrefunds='submitrefunds'></refundsForem>
  </a-modal>
  <a-modal  :keyboard="false"
    title="标记发货（支持拆单发货，可勾选指定商品依次分两个物流进行发货）"
    :width='1300'
    centered
    :footer="null"
    v-model:visible="showDeliver"
    destroyOnClose
  >
    <deliverForem :deliverData='addressData' v-on:submitdeliver='submitdeliver'></deliverForem>
  </a-modal>
</template>
<script>
import { DownOutlined,UpOutlined } from "@ant-design/icons-vue";
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getAgentList } from "@/api/agent";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keywords: "",
  level_id: undefined,
  page: 1,
  limit: 10,
  start_time:'',
  end_time:'',
  select:'',
  value1:7
};
export default {
  components: { DownOutlined ,UpOutlined},
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([
      {
        id:1,
        name: `Edward King `,
        age: 32,
        address: `London, Park Lane no. `,
        userInfo:'My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.'
      },
      {
        id:2,
        name: `Edward King `,
        age: 32,
        address: `London, Park Lane no. `,
        userInfo:'My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.'
      }
    ]);
    const state = reactive({
      open:false,
      showAddress:false,
      showRefunds:false,
      showDeliver:false,
      listLoading: false,
      time:[],
      total: 1,
      selectedRowKeys:[],
      addressData:{
        name: '垃圾',
        phone: '18335903534',
        province: 110000, 
        city: 110100, 
        region: 110101,
        more: '及其详细的地址',
      }
    });
    let columns = [
      {
        title: "订单商品",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "总数量/件",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "交易信息",
        dataIndex: "age",
        key: "age",
      },
      {
        title: "支付方式",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "订单状态",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    const momentTime = inject('momentTime')

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
      initData(search.value);
    }
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    }
    //确认修改地址
    const submitAddress = (e) =>{
      console.log(e)
    }
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getAgentList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) =>{
      search.value.keywords = ''
    }
    
    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      // initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      momentTime,
      onChange,
      onSelectChange,
      submitAddress,
      inputSelect
    };
  },
};
</script>